(function() {
  'use strict';

  angular
    .module('admin.awards.service', [])
    .factory('AwardsService', AwardsService);

  /** @ngInject */
  function AwardsService($http, $q, API) {

    function listDraft(start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/coin_award_types/unpublished?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    function listPublished(start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/coin_award_types/published?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    function listUnpublished(start, limit){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/coin_award_types/archived?start=' + start + '&limit=' + limit)
        .success(defered.resolve);

      return defered.promise;
    }

    function get(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/coin_award_types/' + id)
        .success(defered.resolve);

      return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/coin_award_types', model)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/coin_award_types/' + id, model)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/coin_award_types/' + id)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    function publish(id){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/coin_award_types/' + id + '/publish')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function unpublish(id){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/coin_award_types/' + id + '/unpublish')
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listSegmentation(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/coin_award_types/' + id + '/user_segments')
        .success(defered.resolve);

      return defered.promise;
    }

    function listSegmentationUsers(id){
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/coin_award_types/' + id + '/user_segmenter_users')
        .success(defered.resolve);

      return defered.promise;
    }

    function addSegmentation(id, segmentId){
      var defered = $q.defer();

      $http.post(API.API_URL + 'admin/coin_award_types/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeSegmentation(id, segmentId){
      var defered = $q.defer();

      $http.delete(API.API_URL + 'admin/coin_award_types/' + id + '/user_segments/' + segmentId)
        .success(defered.resolve);

      return defered.promise;
    }

    function batch(model){
        var defer = $q.defer();

        $http.post(API.API_URL + 'admin/users/cash/batch_award?credit_type=' + model.k, model)
            .success(defer.resolve)
            .error(defer.reject);

        return defer.promise;
    }

    function getTranslation(id) {
      var defered = $q.defer();

      $http.get(API.API_URL + "admin/coin_award_type_translations/" + id).success(defered.resolve);

      return defered.promise;
    }

    function saveTranslation(id, model) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "admin/coin_award_types/" + id + "/coin_award_type_translations?automatic=true", model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateTranslation(id, model) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "admin/coin_award_type_translations/" + id + '?automatic=true', model)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function removeTranslation(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "admin/coin_award_type_translations/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function listTranslations(id) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "admin/coin_award_types/" + id + "/coin_award_type_translations")
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return{
      listDraft: listDraft,
      listPublished: listPublished,
      listUnpublished: listUnpublished,
      get: get,
      save: save,
      update: update,
      remove: remove,
      publish: publish,
      unpublish: unpublish,
      listSegmentation: listSegmentation,
      listSegmentationUsers: listSegmentationUsers,
      addSegmentation: addSegmentation,
      removeSegmentation: removeSegmentation,
      batch: batch,
      saveTranslation: saveTranslation,
      updateTranslation: updateTranslation,
      removeTranslation: removeTranslation,
      listTranslations: listTranslations,
      getTranslation: getTranslation,
    };

  }

})();
